import App from '../components/App';
import propsAll from '../configs/propsAll';
import StaticAll from '../sections/static/All';

export default function FontGenerator() {
  return (
    <App {...propsAll}>
      <StaticAll />
    </App>
  );
}
